<template>
  <CustomDialog
    v-model="dialog"
    ref="customDialog"
    hideFooter
    @cancel="close()"
  >
    <div class="d-flex flex-column pb-4 mt-n6">
      <div class="text-h5 font-weight-bold text-center mb-2">
        Booster aplicado com sucesso!
      </div>

      <div class="text-body-1 text-center mb-3">
        Você adquiriu +{{ tokensCount }}
        {{ tokensCount > 1 ? "novos números" : "novo número" }}. Você pode
        acompanhar o sorteio em andamento ou adquira mais números, Boa sorte! 🍀
      </div>

      <div class="text-body-2 text-center mb-2">
        {{ tokensCount > 1 ? "Seus números" : "Seu número" }}
      </div>

      <v-card
        v-if="tokensCount <= 1"
        class="card py-1 align-self-center"
        color="neutral3"
        :class="{
          'lucky-ticket': luckyTokens.find((el) => el.token === tokens[0]),
        }"
      >
        <div class="text-h4 font-weight-black token">
          {{ tokens[0] }}
        </div>
      </v-card>

      <v-slide-group v-else show-arrows>
        <v-slide-item v-for="(item, i) in tokens" :key="i">
          <v-card
            class="card py-1 align-self-center mr-2"
            color="neutral3"
            :class="{
              'lucky-ticket': luckyTokens.find((el) => el.token === item),
            }"
          >
            <div class="text-body-1 font-weight-black token">
              {{ item }}
            </div>
          </v-card>
        </v-slide-item>

        <v-slide-item v-if="tokensCount > 10">
          <v-card
            v-if="seeMore"
            class="card py-1 align-self-center mr-2"
            color="primary"
            height="100%"
            :to="{ name: 'Result', params: { id: _currentRaffle?._id } }"
            @click="close()"
          >
            <div
              class="d-flex fill-height align-center justify-center neutral--text"
            >
              Ver mais
            </div>
          </v-card>

          <v-card
            v-else
            class="card py-1 align-self-center mr-2"
            color="neutral3"
          >
            <div class="text-body-1 font-weight-black token">
              e +{{ tokensCount - 10 }}
            </div>
          </v-card>
        </v-slide-item>
      </v-slide-group>

      <v-card
        v-if="luckyTokens.length"
        class="card pa-4 mt-4"
        color="neutral2"
        outlined
      >
        <div class="text-center text-body-1">
          Parabéns! Você encontrou {{ luckyTokens.length }}
          <span class="font-weight-bold primary--text">cotas premiadas</span>, o
          valor de
          <span class="font-weight-bold primary--text">
            R$ {{ currencyMask(luckyTokens.length * 100) }}
            <!-- {{
              currencyMask(
                luckyTokens.reduce(
                  (sum, item) => sum + (item.awards?.cash || 0),
                  0
                )
              )
            }} -->
          </span>
          foi creditado a sua carteira!
        </div>
      </v-card>

      <div
        v-if="$route.name !== 'Result' && seeMore"
        class="mt-6 d-flex align-center justify-center"
      >
        <v-btn
          class="btn"
          color="primary"
          :to="{ name: 'Result', params: { id: _currentRaffle?._id } }"
          rounded
          @click="close()"
        >
          <span> Ver todos os meus números </span>

          <v-icon right> fas fa-chevron-right </v-icon>
        </v-btn>
      </div>

      <Confetti v-if="confetti" />
    </div>
  </CustomDialog>
</template>

<script>
import { mapGetters } from "vuex";
import { currencyMask } from "@/helpers";
import CustomDialog from "@/components/customDialog/CustomDialog";
import Confetti from "@/components/confetti/Confetti.vue";

export default {
  name: "TokenDialog",

  props: {
    seeMore: {
      type: Boolean,
      default: true,
    },
  },

  components: {
    CustomDialog,
    Confetti,
  },

  data() {
    return {
      dialog: false,
      tokens: [],
      luckyTokens: [],
      tokensCount: 0,
      prizeSound: null,
      confetti: false,
    };
  },

  beforeMount() {
    this.prizeSound = new Audio(require("@/assets/sounds/tada.mp3"));
  },

  computed: {
    ...mapGetters({
      _currentRaffle: "currentRaffle",
    }),
  },

  methods: {
    triggerPrizeSound() {
      if (!this.prizeSound) return;

      const playPromise = this.prizeSound.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // ignore
        });
      }
    },

    open(data) {
      this.tokens = data.tokens;
      this.luckyTokens = data.luckyTokens;
      this.tokensCount = data.tokensCount;

      if (this.luckyTokens.length) {
        this.triggerPrizeSound();
        this.confetti = true;
      }

      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.tokens = [];
      this.luckyTokens = [];
      this.tokensCount = 0;

      this.$emit("closed");
    },

    currencyMask,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
